import React from 'react';
import ArticlesBreadcrumbs from '../components/ArticlesBreadcrumbs';
import ArticlesMain from '../components/ArticlesMain';

const Articles = () => (
  <>
    <ArticlesBreadcrumbs />
    <ArticlesMain />
  </>
);

export default Articles;